export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-7.5ccb3e17.png";